import { Grid } from "@mantine/core";
import PdfOnlyViewer from "./PdfOnlyViewer";

export function PdfFileView({ file }: { file: string }) {
  return (
    <Grid>
      <Grid.Col span={12}>
        <PdfOnlyViewer files={file}></PdfOnlyViewer>
      </Grid.Col>
    </Grid>
  );
}
